import { UserClient, User } from '@/type';
import api from '@/API';

export default {
  findAll(clientId: number): Promise<UserClient[]> {
    return api
      .get(`clients/${clientId}/users`)
      .then(response => response.data);
  },
  findUnassigned(clientId: number): Promise<User[]> {
    return api
      .get(`clients/${clientId}/users/unassigned`)
      .then(response => response.data);
  },
};
